import { CollectionViewer, DataSource } from '@angular/cdk/collections';
import { PageEvent } from '@angular/material/paginator';
import { IResponseBody } from '../interfaces/response-body';
import { BehaviorSubject, Subscription as RxSubscription } from 'rxjs';

export abstract class ApiDataSource extends DataSource<any> {
  public loading: BehaviorSubject<boolean> = new BehaviorSubject(false);
  public PageEvent: BehaviorSubject<PageEvent> = new BehaviorSubject(null);
  public filter: BehaviorSubject<{} | null> = new BehaviorSubject(null);

  protected abstract Data: BehaviorSubject<any>;

  protected Subscriptions: RxSubscription[] = [];

  public connect(collectionViewer?: CollectionViewer) {
    return this.Data;
  }

  public disconnect(collectionViewer?: CollectionViewer) {
    this.Subscriptions.forEach((Subscription) => Subscription.unsubscribe());

    this.Subscriptions = [];
  }

  public loadWithPageEvent(PageEvent?: PageEvent) {
    this.loading.next(true);
    this.Data.next([]);
    this.loadData(PageEvent)
      .then((responseBody: IResponseBody) => {
        this.setData(responseBody);
        this.PageEvent.next(responseBody.pageEvent);
        this.loading.next(false);
      })
      .catch(() => this.loading.next(false));
  }

  public resetFilters(filters: {}) {
    this.PageEvent.next(null);
    this.filter.next(filters);
  }

  public setFilter(key: string, value: string) {
    const filter = this.filter.value || {};

    if (value) {
      filter[key] = value;
    } else {
      filter.hasOwnProperty(key) && delete filter[key];
    }

    this.PageEvent.next(null);
    this.filter.next(filter);
  }

  public setFilters(newFitlers: Array<{ filter: string; value: string }>) {
    const filter = this.filter.value || {};

    newFitlers.map((newfilter) => {
      if (newfilter.value) {
        filter[newfilter.filter] = newfilter.value;
      } else {
        filter.hasOwnProperty(newfilter.filter) &&
          delete filter[newfilter.filter];
      }
    });

    this.PageEvent.next(null);
    this.filter.next(filter);
  }

  protected abstract loadData(
    PageEvent: PageEvent
  ): Promise<void | IResponseBody>;

  protected abstract setData(ResponseBody: IResponseBody): void;
}
